// src/slices/bookingSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  address: "",
  duration: "1",
  selectedDate: null,
  datas: null,
  selectedSlots: [],
  addressOptions: [],
  timeSlots: {
    morning: [],
    afternoon: [],
    evening: [],
  },
};

const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    setAddress(state, action) {
      state.address = action.payload;
    },
    setDuration(state, action) {
      state.duration = action.payload;
    },
    setSelectedDate(state, action) {
      state.selectedDate = action.payload;
    },
    setDatas(state, action) {
      state.datas = action.payload;
    },
    setSelectedSlots(state, action) {
      state.selectedSlots = Array.isArray(action.payload) ? action.payload : [];
    },
    setTimeSlots(state, action) {
      state.timeSlots = action.payload;
    },
    setAddressOptions: (state, action) => {
      state.addressOptions = action.payload; // Add this action to set fetched addresses
    },
    resetBooking(state) {
      return initialState; // Reset state to initial
    },
  },
});

export const {
  setAddress,
  setDuration,
  setSelectedDate,
  setDatas,
  setSelectedSlots,
  setTimeSlots,
  resetBooking,
  setAddressOptions,
} = bookingSlice.actions;

export default bookingSlice.reducer;
